// src/api.js
import axios from "axios";

// ===== Storage keys =====
const KEY_TOKEN = "token";
const KEY_ROLE = "role";
const KEY_USER = "user_id";
const KEY_API = "api.base";

// ===== Resolve BASE URL =====
const ENV_BASE =
  (typeof import.meta !== "undefined" &&
    import.meta.env &&
    import.meta.env.VITE_API_BASE) ||
  process.env.REACT_APP_API_BASE_URL ||
  "https://sipedasapi.bkkpangkalpinang.com/api";

function normalizeBase(url) {
  return (url || "").trim().replace(/\/+$/g, "");
}

const START_BASE =
  normalizeBase(localStorage.getItem(KEY_API)) || normalizeBase(ENV_BASE);

// ✅ LEGACY export: BASE
export let BASE = START_BASE || "https://sipedasapi.bkkpangkalpinang.com/api";

// ===== Axios instance utama =====
export const api = axios.create({
  baseURL: BASE,
  withCredentials: false,
  timeout: 20000,
  headers: {
    Accept: "application/json",
    "Content-Type": "application/json",
  },
});

// ===== Helpers BASE URL =====
export function setApiBase(url) {
  const base = normalizeBase(url) || api.defaults.baseURL;
  localStorage.setItem(KEY_API, base);
  api.defaults.baseURL = base;
  BASE = base;
  return base;
}
export function getApiBase() {
  return api.defaults.baseURL;
}

// ===== Helpers Token =====
export function setAuthToken(token) {
  if (token) {
    localStorage.setItem(KEY_TOKEN, token);
    api.defaults.headers.common.Authorization = `Bearer ${token}`;
  } else {
    localStorage.removeItem(KEY_TOKEN);
    delete api.defaults.headers.common.Authorization;
  }
}

export function clearSessionAndRedirect() {
  localStorage.removeItem(KEY_TOKEN);
  localStorage.removeItem(KEY_ROLE);
  localStorage.removeItem(KEY_USER);
  // api.base sengaja tidak dihapus
  if (!window.location.pathname.includes("/login")) {
    window.location.assign("/login");
  }
}

// Initialize Authorization dari storage saat load
(() => {
  const saved = localStorage.getItem(KEY_TOKEN);
  if (saved) {
    api.defaults.headers.common.Authorization = `Bearer ${saved}`;
  }
})();

// ===== Interceptors =====
api.interceptors.request.use((config) => {
  const token = localStorage.getItem(KEY_TOKEN);
  if (token) {
    config.headers = config.headers || {};
    if (!config.headers.Authorization) {
      config.headers.Authorization = `Bearer ${token}`;
    }
  }
  return config;
});

api.interceptors.response.use(
  (res) => res,
  (err) => {
    const status = err?.response?.status;

    if (status === 401 || status === 419) {
      clearSessionAndRedirect();
    } else if (status === 403) {
      console.warn("Forbidden (403): akses tidak diizinkan.");
    } else if (!status) {
      console.error("Network/CORS error:", err?.message || err);
    }

    return Promise.reject(err);
  }
);

// ===== Shorthand opsional =====
export const get = (url, config) => api.get(url, config);
export const post = (url, data, config) => api.post(url, data, config);
export const put = (url, data, config) => api.put(url, data, config);
export const patch = (url, data, config) => api.patch(url, data, config);
export const del = (url, config) => api.delete(url, config);

export default api;
